<template>
  <v-card light
          class="acc-membership-before-pay"
          v-if="subscription">
    <v-card-text>
      <v-container fluid>
        <v-row>
          <v-col cols="12" md="6">
            <v-text-field readonly
                          :label="$t('my_account.acc_membership_price')"
                          :value="subscription.price"></v-text-field>
            <v-row>
              <v-col>
                <v-text-field v-if="!discountCodeRecord"
                              outlined
                              hide-details="auto"
                              :label="$t('booking.discount_code')"
                              v-model="discountCode"
                              :error-count="!!discountCodeErrorMessage ? 1 : 0"
                              :error-messages="discountCodeErrorMessage"
                              append-icon="mdi-check"
                              @click:append="applyDiscountCode"
                              @keydown.enter="applyDiscountCode"></v-text-field>
                <v-text-field v-if="discountCodeRecord"
                              readonly
                              hide-details="auto"
                              :label="$t('booking.discount_code')"
                              :value="discountCode"
                              :error-count="!!discountCodeErrorMessage ? 2 : 0"
                              :error-messages="discountCodeErrorMessage ? [discountCodeDescriptions, discountCodeErrorMessage] : []"
                              append-outer-icon="mdi-close"
                              @click:append-outer="clearDiscountCode"
                              :hint="discountCodeDescriptions"
                              persistent-hint>
                </v-text-field>
              </v-col>
            </v-row>
            <v-text-field readonly
                          hide-details
                          :label="$t('package.price')"
                          :value="price"></v-text-field>
          </v-col>
          <v-col cols="12" md="6">
            <v-row class="booking-preview-form-title">
              <v-col class="pb-0 text-h6">{{ $t('booking.payment_method') }}</v-col>
            </v-row>
            <v-row v-if="price <= 0">
              <v-col cols="12"
                     :class="['pa-8', 'text-center', 'event-pay-dialog-payment-method', 'active']">
                {{ $t('booking.no_need_to_pay') }}
              </v-col>
            </v-row>
            <v-row v-if="price > 0">
              <v-col class="pt-0">
                <v-item-group>
                  <v-container>
                    <v-row>
                      <v-col cols="12"
                             :class="['event-pay-dialog-payment-method', {'active': paymentMethod === 'cyber_source'}]"
                             @click="paymentMethod = 'cyber_source'">
                        <v-img :src="require('@/assets/logo-credit-cards.png')"></v-img>
                      </v-col>
                      <!--                                <v-col cols="1"></v-col>-->
                      <!--                                <v-col cols="4"-->
                      <!--                                       :class="['booking-preview-payment-method', {'active': paymentMethod === 'union_pay'}]"-->
                      <!--                                       @click="paymentMethod = 'union_pay'">-->
                      <!--                                  <v-img :src="require('../../../assets/logo-union-pay.png')"></v-img>-->
                      <!--                                </v-col>-->
                    </v-row>
                    <v-row v-if="paymentMethod === 'cyber_source'">
                      <v-col>
                        <v-radio-group v-model="selectedPaymentToken">
                          <v-radio v-for="paymentToken in paymentTokens"
                                   :key="paymentToken.id"
                                   :value="paymentToken.id">
                            <template #label>
                              <v-img :src="cardTypeLogo[paymentToken.card_type]"
                                     :max-width="40"
                                     :max-height="30"
                                     class="mr-4"></v-img>
                              {{ `${paymentToken.card_number} (${paymentToken.card_expiry_date})` }}
                            </template>
                          </v-radio>
                          <v-radio :value="false">
                            <template #label>
                              <v-icon class="mr-4">fas fa-plus-square</v-icon>
                              {{ $t('booking_preview.add_payment_token') }}
                            </template>
                          </v-radio>
                        </v-radio-group>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-item-group>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>

    <v-card-actions>
      <v-spacer></v-spacer>

      <v-btn text color="primary"
             :disabled="!paymentMethod"
             @click="initMembershipPayment()">
        {{ $t('my_event_list.pay') }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import {computed, onMounted, ref, watch} from '@vue/composition-api';

export default {
  name: 'AccMembershipBeforePay',
  setup(props, {root}) {
    const subscription = ref(null);
    const getSubscription = function () {
      root.$callAPI('aafb/membership/create/', {}, function (response) {
        subscription.value = response.body.subscription;

        getAppliedDiscountCode();
      });
    }

    const discountCode = ref(null);
    const discountCodeError = ref(null);
    const discountCodeRecord = ref(null);
    const discountCodeErrorMessage = computed(() => {
      if (discountCodeError.value) return discountCodeError.value;

      if (discountCodeRecord.value && subscription.value) {
        const discountCode = discountCodeRecord.value.discount_code;
        // Discount Code Type
        if (discountCode.type !== 'MEMBERSHIP') return root.$t('error_messages.discount_code_not_applicable');
      }

      return null;
    })
    const discountCodeDescriptions = computed(() => {
      if (discountCodeRecord.value) {
        return root.$getDiscountCodeDescription(discountCodeRecord.value.discount_code);
      }
    })
    const discountCodeDiscount = computed(() => {
      if (discountCodeRecord.value && !discountCodeErrorMessage.value) {
        const discountCode = discountCodeRecord.value.discount_code;

        if (discountCode.discount_value > 0) return discountCode.discount_value;

        return Math.floor(subscription.value.price * discountCode.discount_percentage / 100);
      }

      return 0;
    })
    const getAppliedDiscountCode = function () {
      root.$callAPI('aafb/applied_discount_code/', {
        membership_subscription_id: subscription.value.id,
      }, (response) => {
        if (response.body.record) {
          discountCodeRecord.value = response.body.record;
          discountCode.value = response.body.record.discount_code.code;
        } else {
          discountCodeRecord.value = null;
          discountCode.value = null;
        }
      })
    }
    const applyDiscountCode = function () {
      if (discountCode.value) {
        discountCodeError.value = null;
        root.$callAPI('aafb/membership/apply_code/', {
          'code': discountCode.value,
        }, (response) => {
          if (response.body.record) {
            discountCodeRecord.value = response.body.record;
            discountCode.value = response.body.record.discount_code.code;
          } else {
            discountCodeRecord.value = null;
            discountCode.value = null;
          }
        }, (response) => {
          discountCodeError.value = response.body.msg || 'invalid_discount_code';
          console.log(response);
        })
      }
    }
    const clearDiscountCode = function () {
      if (discountCodeRecord.value && confirm(root.$t('booking.clear_discount_code'))) {
        discountCodeError.value = null;
        root.$callAPI('aafb/membership/clear_code/', {}, () => {
          getAppliedDiscountCode()
        }, (response) => {
          console.log(response);
        })
      }
    }
    const price = computed(() => {
      if (subscription.value) {
        return subscription.value.price - discountCodeDiscount.value;
      }

      return 0;
    })

    const paymentMethod = ref(null);

    // Payment Token
    const selectedPaymentToken = ref(false);
    const paymentTokens = ref([]);
    const cardTypeLogo = ref({
      '001': require('@/assets/visa.jpg'),
      '002': require('@/assets/mastercard.png'),
      '007': require('@/assets/jcb.gif'),
    });
    const getPaymentTokens = function () {
      root.$callAPI('payment/cyber_source/payment_tokens/', {}, (response) => {
        paymentTokens.value = response.body.payment_tokens;

        if (paymentTokens.value.length > 0) {
          selectedPaymentToken.value = paymentTokens.value[0].id;
        }
      })
    }
    watch(() => paymentMethod.value, (newValue) => {
      if (newValue === 'cyber_source') {
        getPaymentTokens();
      }
    })

    const initMembershipPayment = function () {
      if (confirm(root.$t('my_account.confirm_pay_acc_membership'))) {
        root.$callAPI('aafb/membership/init_payment/', {
          subscription_id: subscription.value.id,
          payment_method: paymentMethod.value,
          payment_token_id: selectedPaymentToken.value,
        }, function (response) {
          postForm(response.body.url, response.body.params)
        })
      }
    };
    const postForm = function (path, params, method = 'post') {
      const form = document.createElement('form');
      form.method = method;
      form.action = path;

      for (const key in params) {
        if (params.hasOwnProperty(key)) {
          const hiddenField = document.createElement('input');
          hiddenField.type = 'hidden';
          hiddenField.name = key;
          hiddenField.value = params[key];

          form.appendChild(hiddenField);
        }
      }

      document.body.appendChild(form);
      form.submit();
      root.$startLoading();
    }

    onMounted(() => {
      getSubscription();
    });

    return {
      subscription,

      discountCode,
      discountCodeRecord,
      discountCodeErrorMessage,
      discountCodeDescriptions,
      discountCodeDiscount,
      applyDiscountCode,
      clearDiscountCode,
      price,
      paymentMethod,

      selectedPaymentToken,
      paymentTokens,
      cardTypeLogo,

      initMembershipPayment,
    }
  },
}
</script>

<style lang="less">
.acc-membership-before-pay {
  .v-label {
    color: #8E765B;
  }

  .v-input--is-readonly > .v-input__control > .v-input__slot:before {
    display: none;
  }

  .v-input--is-readonly > .v-input__control > .v-input__slot:after {
    display: none;
  }

  .event-pay-dialog-payment-method {
    border: 2px solid rgba(0, 0, 0, 0.2);
    cursor: pointer;

    &:hover, &.active {
      border-color: #8E765B;
    }

    .event-pay-dialog-payment-method-logo {

    }

    &.pay-by-octopus {
      background: #F3F4F8;

      .pay-by-octopus-wrapper {
        display: flex;
        flex-wrap: wrap;
        align-items: center;

        .v-image {
          -webkit-box-flex: 0;
          -ms-flex: 0 0 25%;
          flex: 0 0 25%;
          max-width: 25%;
        }


        .pay-by-octopus-description {
          color: #B3B4B8;
          font-size: 90%;
          text-align: left;
        }
      }
    }
  }
}
</style>
